export default "__VITE_ASSET__ZpwQaeb8__"